/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {loadMenusByRole} from '../../../../app/pages/definition/menu/Api'
import {IMenuModel} from '../../../../app/pages/definition/menu/MenuModel'
import { ADMIN_CORPORATE_PATH } from '../../../../app/pages/admin/corporate/CorporateModel'
import { ADMIN_USER_CORPORATE_PATH } from '../../../../app/pages/admin/user-corporate/UserCorporateModel'
import { useIsAdmin } from '../../../../shared/utils/useIsAdmin'

function filterActive(items: IMenuModel[]): IMenuModel[] {
  return items
    .filter((m) => m.isActive)
    .map((m) => ({
      ...m,
      children: m.children ? filterActive(m.children) : [],
    }))
}

export function AsideMenuMain() {
  const intl = useIntl()
  const isAdmin = useIsAdmin()
  const [menuTree, setMenuTree] = useState<IMenuModel[]>([])

  useEffect(() => {
    loadMenusByRole()
      .then((res) => {
        setMenuTree(filterActive(res.data.payload))
      })
      .catch(() => {})
  }, [])

  const renderMenuItems = (nodes: IMenuModel[]) => {
    return nodes.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <AsideMenuItemWithSub
            key={node.id}
            to={node.path}
            title={node.title}
            fontIcon={node.icon}
          >
            {renderMenuItems(node.children)}
          </AsideMenuItemWithSub>
        )
      }
      return (
        <AsideMenuItem
          key={node.id}
          to={node.path}
          title={node.title}
          fontIcon={node.icon}
        />
      )
    })
  }

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-speedometer2'
      /> 
      {isAdmin && (
        <>
          <AsideMenuItem to={ADMIN_CORPORATE_PATH} title='Firma Yönetimi' fontIcon='bi-buildings' />
          <AsideMenuItem to={ADMIN_USER_CORPORATE_PATH} title='Kullanıcı - Firma' fontIcon='bi-person-badge' />
        </>
      )}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Menü</span>
        </div>
      </div>
      {renderMenuItems(menuTree)}
    </>
  )
}
